module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0043.jpg?v=63d6b671";